module.exports = __webpack_public_path__ + "static/media/IMG_20191204_133134.e3f1c3f4.jpg";